<hd-dialog [closeRequested]="closeRequested" dialogTitle="issueReport.title">
  <ng-container dialogActions>
    @if (!loader$$() && !submitedIssueLink$$()) {
      <button class="filled" (click)="submit()"><i class="icon-send"></i>{{ 'issueReport.action' | translate }}</button>
    }
  </ng-container>
  <ng-container dialogContent>
    @if (loader$$()) {
      <hd-spinner/>
    } @else if (submitedIssueLink$$()) {
      @if (submitedIssueLink$$(); as issueLink) {
        <hd-labeled-link label="issueReport.success" labelSize="extra-large" [link]="{ url: issueLink, label: ('issueReport.link.label' | translate)}"/>
      }
    } @else {
      <div class="flex flex-col gap-6">
        <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-4">
          <hd-textarea [control]="form.controls.name" label="issueReport.name.label" description="issueReport.name.label.description"/>
          <hd-textarea [control]="form.controls.descriptionExpected" label="issueReport.expected.label" description="issueReport.expected.label.description"/>
          <hd-textarea [control]="form.controls.descriptionActual" label="issueReport.actual.label" description="issueReport.actual.label.description"/>
        </form>
      </div>
    }
  </ng-container>
</hd-dialog>
